import * as React from "react";
import { Dispatch, useState } from "react";
import styled from "@mui/material/styles/styled";
import TextField from "@mui/material/TextField/TextField";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { DataInput } from "../../dataInputTypes";
import {
  AGE_RELATION_ID,
  RANGE_QUALIFIER_FEATURE_ID,
} from "fe-common/graphql/dao";
import { MeasurementUnits } from "fe-common/graphql";
import { LevelNumericUnitSelectMenu } from "./levelNumericUnitSelectMenu";

//region [[ Styles ]]

const LevelNumericInputView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const NumericLabTestInput = styled(TextField)(({ theme }) => ({
  width: "100px",
  textAlign: "center",
}));

const useStyles = makeStyles((theme?: Theme) =>
  createStyles({
    input: {
      textAlign: "center",
      backgroundColor: "white",
      borderRadius: "25px",
      height: "40px",
      overflow: "hidden",
      "& .MuiOutlinedInput-input": {
        textAlign: "center",
      },
    },
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LevelNumericInputProps {
  onChange: Dispatch<DataInput>;
  response: DataInput;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LevelNumericInput = ({ ...props }: LevelNumericInputProps) => {
  const classes = useStyles();

  const getValue = () => {
    return props.response?.qualifiers && props.response?.qualifiers.length
      ? props.response?.qualifiers[0].range?.low
      : null;
  };

  const getUnit = () => {
    return props.response?.qualifiers && props.response?.qualifiers.length
      ? props.response?.qualifiers[0].range?.units
      : MeasurementUnits.Microliter;
  };

  const [value, setValue] = useState(getValue());

  const [selectedUnit, setSelectedUnit] = useState(getUnit());

  const onChangeUnit = (unit: MeasurementUnits) => {
    setSelectedUnit(unit);
  };

  const onChangeInput = (event) => {
    const inputValue = event.target.value;

    if (
      inputValue !== "" &&
      !(inputValue.charAt(inputValue.length - 1) === ".") &&
      !(inputValue.charAt(inputValue.length - 1) === "0") &&
      !Number(inputValue.charAt(inputValue.length - 1))
    ) {
      return;
    }

    setValue(inputValue);

    const numericQualifier = {
      freeText: "",
      source: null,
      relation: {
        id: AGE_RELATION_ID,
        name: "",
        type: null,
        multi: null,
        essence: null,
      },
      name: "",
      value: {
        patientDescription: "",
        description: { text: "" },
        id: RANGE_QUALIFIER_FEATURE_ID,
        name: "",
        shortname: "",
        category: null,
        parents: null,
        range: null,
      },
      negate: null,
      range: {
        low: parseInt(inputValue),
        high: parseInt(inputValue),
        units: selectedUnit,
        complexUnits: null,
      },
    };

    props.onChange({
      qualifiers: [numericQualifier],
    });
  };

  return (
    <LevelNumericInputView>
      <NumericLabTestInput
        value={value}
        id={"max"}
        onChange={onChangeInput}
        variant={"outlined"}
        InputProps={{
          classes: {
            root: classes.input,
          },
        }}
      />

      <LevelNumericUnitSelectMenu
        value={selectedUnit}
        onSelect={onChangeUnit}
      />
    </LevelNumericInputView>
  );
};
